












































































































import BaseComponent from '@/core/base.component';
import Component from 'vue-class-component';
import {
  DeliveryFounderConsultContractDto,
  DeliveryFounderConsultContractListDto,
  DeliveryFounderConsultUpdateDto,
} from '../../../dto';
import DeliveryFounderConsultContractService from '../../../services/delivery-founder-consult-contract.service';
import toast from '../../../../resources/assets/js/services/toast.js';
import { Pagination } from '@/common';
import deliverySpaceService from '@/services/delivery-space.service';

@Component({
  name: 'DeliverySpaceDetailContractList',
})
export default class DeliverySpaceDetailContractList extends BaseComponent {
  private deliveryFounderConsultContractList: DeliveryFounderConsultContractDto[] = [];
  private deliveryFounderConsultContractListCount = 0;
  private deliveryFounderConsultContractSearchDto = new DeliveryFounderConsultContractListDto();
  private deliveryFounderConsultContractDto = new DeliveryFounderConsultContractDto();
  private deleteConfirmMsg = '';
  private selectedContract = new DeliveryFounderConsultContractDto();
  private pagination = new Pagination();
  private dataLoading = false;

  search(isPagination?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    }
    this.pagination.limit = 5;

    DeliveryFounderConsultContractService.findAll(
      this.deliveryFounderConsultContractSearchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.dataLoading = false;
        this.deliveryFounderConsultContractList = res.data.items;
        this.deliveryFounderConsultContractListCount = res.data.totalCount;
      }
    });
  }

  // 계약 삭제
  selectContract(contract: DeliveryFounderConsultContractDto) {
    this.deleteConfirmMsg = '';
    this.selectedContract = contract;
  }

  deleteContract() {
    if (this.deleteConfirmMsg === '정말로 삭제하시겠습니까?') {
      const contractNo = this.selectedContract.no;
      DeliveryFounderConsultContractService.deleteContract(
        contractNo,
      ).subscribe(res => {
        if (res) {
          this.search();
          this.$bvModal.hide('delete_contract');
          this.$root.$emit('delete_contract_list');
          toast.success('삭제완료');
        }
      });
    }
  }

  paginateSearch() {
    this.search(true);
  }

  mounted() {
    this.$root.$on('find_contract_list', typeNo => {
      this.deliveryFounderConsultContractSearchDto.deliverySpaceNo = typeNo;
      this.search();
    });
  }
}
